"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CfgCssClassesListCtl = /** @class */ (function (_super) {
    __extends(CfgCssClassesListCtl, _super);
    function CfgCssClassesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_css_class_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_class_name; });
        _this.dk_css_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_type_code; });
        _this.dk_css_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_type_title; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    CfgCssClassesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CfgCssClassesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    CfgCssClassesListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListCssClassesGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    css_class_name: resp.list[i].css_class_name,
                    css_type_code: resp.list[i].css_type_code,
                    css_type_title: resp.list[i].css_type_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_deprecated: resp.list[i].is_deprecated
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCssClassesListCtl.prototype.DoSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        webAApi_1.DoSetCssClassIsDeprecated.exec({ data: { app_css_class_id: key, is_deprecated: isDeprecated } }, function (resp) {
            var tmp = _this.getById(key);
            tmp.is_deprecated = isDeprecated;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCssClassesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCssClass.exec({
            data: {
                css_class_name: data.css_class_name,
                css_type_code: data.css_type_code,
                is_deprecated: data.is_deprecated,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                css_class_name: data.css_class_name,
                css_type_code: data.css_type_code,
                css_type_title: resp.css_type_title,
                is_deprecated: data.is_deprecated,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCssClassesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCssClass.exec({
                data: {
                    app_css_class_id: data.key,
                    css_class_name: data.css_class_name,
                    css_type_code: data.css_type_code,
                    is_deprecated: data.is_deprecated,
                }
            }, function (resp) {
                _tmp.css_class_name = data.css_class_name;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.css_type_code = data.css_type_code;
                _tmp.css_type_title = resp.css_type_title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgCssClassesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CfgCssClassesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCssClass.exec({ data: { app_css_class_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CfgCssClassesListCtl;
}(BaseController_1.BaseController));
exports.CfgCssClassesListCtl = CfgCssClassesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ctl/CfgClassListCtl.ts
// module id = 938
// module chunks = 0